__turbopack_context__.v({
  "buttons": "_0OIBKa_buttons",
  "catalogueCell": "_0OIBKa_catalogueCell",
  "closeButton": "_0OIBKa_closeButton",
  "content": "_0OIBKa_content",
  "dimensions": "_0OIBKa_dimensions",
  "extraInfo": "_0OIBKa_extraInfo",
  "imageViewer": "_0OIBKa_imageViewer",
  "name": "_0OIBKa_name",
  "oldPrice": "_0OIBKa_oldPrice",
  "price": "_0OIBKa_price",
  "promo": "_0OIBKa_promo",
  "promoBox": "_0OIBKa_promoBox",
  "promoDays": "_0OIBKa_promoDays",
  "promoText": "_0OIBKa_promoText",
  "promotion": "_0OIBKa_promotion",
  "scratchedPrice": "_0OIBKa_scratchedPrice",
  "specialPromo": "_0OIBKa_specialPromo",
  "wrapper": "_0OIBKa_wrapper",
});
